export const ROUTES = {
  HOME: "/",
  CART: "/cart",
  CATEGORY: "/categories/:id",
  PROFILE: "/profile",
  PRODUCT: "/products/:id",
};
